import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import TransitionContainer from '../../components/Transition/TranstionContainer';

import VoteRegistrationStep7Form from '../../components/VoteRegistration/VoteRegistrationStep7Form';

import { onGoToStep, saveForm } from './actions';
import { cacheFormData } from '../../utils/formCaching/actions';

import {
    ContainerStyled,
    LegalInfoWrapper,
    FormWrapper
} from '../DefaultStyles/AssessmentDetails';

import { StatesId } from '../../utils/enums';

import VoteRegistrationSidebar from '../../components/VoteRegistration/VoteRegistrationSidebar';

import LegalInfo from '../../components/Widget/LegalInfo';

const VoteRegistrationStep7 = props => (
    <TransitionContainer
        isSubmitting={props.isSubmitting}
        isBackTransition={props.isBackTransition}
        zIndex={32}
    >
        <ContainerStyled>
            <VoteRegistrationSidebar loadRep={true} title={'Voter Registration'} />
            <FormWrapper>
                <VoteRegistrationStep7Form
                    onBack={() => {
                        props.onGoToStep(
                            6,
                            'back',
                            null,
                            null,
                            [4, 5, 6],
                            props.formData
                        );
                    }}
                    onSubmit={values => {
                        props.cacheFormData(values);
                        props.saveForm(values, [8], null, props.formData);
                    }}
                    states={props.states}
                />
                {props.isMobileResolution && (
                    <LegalInfoWrapper>
                        <LegalInfo />
                    </LegalInfoWrapper>
                )}
            </FormWrapper>
        </ContainerStyled>
    </TransitionContainer>
);

VoteRegistrationStep7.propTypes = {
    onGoToStep: PropTypes.func.isRequired,
    saveForm: PropTypes.func.isRequired,
    formData: PropTypes.object,
    states: PropTypes.array,
    isSubmitting: PropTypes.bool,
    isBackTransition: PropTypes.bool,
    isMobileResolution: PropTypes.bool,
    cacheFormData: PropTypes.func.isRequired
};

export default connect(
    state => ({
        formData: state.voteRegistration.formData,
        states: StatesId,
        isSubmitting: state.voteRegistration.isSubmitting,
        isBackTransition: state.voteRegistration.isBackTransition,
        isMobileResolution: state.widget.isMobileResolution
    }),
    { onGoToStep, saveForm, cacheFormData }
)(VoteRegistrationStep7);
